import WeddingHero from './../components/WeddingHero.jsx';
import WeddingShowcase from './../components/WeddingShowcase.jsx'; 
import Testemonials from './../components/Testemonials.jsx'; 
import WeddingPackages from './../components/WeddingPackages.jsx'; 
import PackageComparison from './../components/PackageComparison.jsx'; 
import WeddingFiles from './../components/WeddingFiles.jsx'; 
import CivilCeremonies from './../components/CivilCeremonies.jsx'; 
import ContactForm from './../components/ContactForm.jsx'; 
import foxTextSplitter from './../assets/images/Splitters/foxTextSplitter.webp'
import WeddingOpenDay from '../components/WeddingOpenDay.jsx';

const Weddings = () => {
  return (
    <div>
      <WeddingHero />
      <WeddingOpenDay />
      <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
      </div>
      <WeddingShowcase />
      <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
      </div>
      <Testemonials />
      <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
      </div>
      <WeddingPackages />
      <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
      </div>
      <PackageComparison />
      <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
      </div>
      <WeddingFiles />
      <CivilCeremonies />
      <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
      </div>
      <ContactForm/>
    </div>
  )
}

export default Weddings